import { useState, useEffect, Fragment, useRef } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";
import MenuTable from "../../helpers/MenuTable";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import SortBy from "../../helpers/SortBy";
import InputCombo from "../../helpers/InputCombo";
import FormatDecimal from "../../helpers/FormatDecimal";

import exmark from "../../exmark.png";


import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Xlsx from "../../exporter/Xlsx";
import ClientReview from "../home/ClientReview";


function Stoped(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


 

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({   

         
        nip:  props.mainView.readFilter('nip',''),   
        nazwa:  props.mainView.readFilter('nazwa',''),   
        fakturowanie:  props.mainView.readFilter('fakturowanie','_x_'),   
      
        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },


        limit: 50,
        page: 1,
        pages: 1,
        show: true,
    });
    const [tab, setTab] = useState(null);

    
    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0);

    const [services, setServices] = useState([]);

    const [view, setView] = useState ( "list");

    const [legend, setLegend] = useState([
        {
            cls:'color_show4',
            title: 'fakturowanie aktualnie wstrzymane',
            filter: {  filed: "fakturowanie", set: "1", typ: "combo"  },
        },

         {
            cls:'color_deleted2',
            title: 'klient, którego należy sprawdzić pod kątem fakturowania',
            filter: {  filed: "fakturowanie", set: "1", typ: "combo"  },
        },

    ]);



    
        const valChangeListener = (filedName, val, correct, msg) => {

            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);
            setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );                                  
            if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 500;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
        
            props.mainView.writeFilter(filedName, val);            
        }


        const goNextNew = () => {
            console.log("goNext");    
            setTab(null);    
        }      

        const filterClear = () => {

            props.mainView.writeFilter('nip', '');
            props.mainView.writeFilter('nazwa', '');
            props.mainView.writeFilter('fakturowanie', '_x_');
    
           
            setFilterParam({
                
                
                nip: '',                 
                nazwa: '',                 
                fakturowanie: '_x_',                 
             
                sortBy: {
                    sort:  "", //asc desc,
                    column: "",
                },

                limit: 50,
                page: 1,
                show: true,
            });
            setTab(null);
        }

        const filterApprove = () => {   
            setTab(null)     
        }



        const onChangePagger = (x_limit, x_page) => {

            setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
            setTab(null);
        }

        const onChangeSortBy = (sortBy) => {

            setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
            setTab(null);
        }



          const changeView = (e ) => {
            var v = e.target.getAttribute('v');
            var id = e.target.getAttribute('id');

            setView({...view, ["v"]:v, ["id"]:id });
            }


            const onBack = ( ) => {                
                    setView({...view, ["v"]:"list", ["id"]:-1 });               
                }

            
            const onSuccess = ( ) => {                
                    setView({...view, ["v"]:"list", ["id"]:-1 });       
                    getTab();
                }

                

    const getTab = () => {
        

        props.mainView.showProgress();       
 

        fetch( Config.url + '/rest_v1_rap,stoped_f', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                props.mainView.hideProgress();    

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                    }else    
                    {
                        setTab(res.result);             
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                   props.mainView.hideProgress();    
         });
                   

         return false;
    }



       

       const keyListener = (e)     => {

                        var code = e.keyCode ? e.keyCode : e.which;    

                        if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                        {
                                e.target.blur();
                                filterClear();
                        }else                            
                        if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                        {
                                filterClear();
                        }else                                                                     
                        if( e.target.nodeName.toLowerCase() == "body" && code === 37 && filterParam.page > 1)  //left
                        {
                                setFilterParam( {...filterParam,   ['page']: filterParam.page-1  } );  
                                setTab(null);
                        }else                                             
                        if(e.target.nodeName.toLowerCase() == "body" && code === 39 && filterParam.page < filterParam.pages)  //right
                        {
                            setFilterParam( {...filterParam,   ['page']: filterParam.page+1  } );  
                            setTab(null);
                        }else                                              
                        if (e.target.nodeName.toLowerCase() == "body" && code === 107) { //add +
                            setView({...view, ["v"]:'new', ["id"]:'-1' });
                        }else 
                        {
                            props.keyListener(e);
                        }

       }


       useEffect( ()=>{

            if(Config.env == "dev") console.log("Stoped.js, listener on");
            window.onkeydown = keyListener;                       
            
            return () => {   
                 if(Config.env == "dev") console.log("Stoped.js, listener off");             
                 window.onkeydown = props.keyListener;
            };

    } );








    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        setView({...view, ["v"]:"list", ["id"]:-1 });       
        setTab(null);
    }



    if(tab == null)
    {
        setTab([]);
        getTab();    
        return <div>
            ...
        </div>
    }


   

     if(view.v == "client")
    {                                 
             return <ClientReview  userData={props.userData} mainView={props.mainView}  keyListener={keyListener}  onBack={onSuccess}  onSuccess={onSuccess}   id={view.id} />
    }

    
    document.title = "Wstrzymane fakturowanie";


            var sortList = [                              
            {column: "firma_nazwa", name: "Nazwa firmy"  },
            ]

    var titleRaport = "Wstrzymane fakturowanie";
    

    return  <div className="view_content">

            

                <h3 className="dash_header">Wstrzymane fakturowanie</h3>

    
               
                            <div className="table_filter">

                                    <div className="filter_controll">   
                                                        <label>NIP: </label>                             
                                                        <InputText   userData={props.userData} value={filterParam.nip}   valChange={valChangeListener} goNext={goNextNew} name="nip" placeholder={"Nazwa: "}   />

                                    </div> 
                                    
                                    <div className="filter_controll">   
                                                        <label>Nazwa: </label>                             
                                                        <InputText   userData={props.userData} value={filterParam.nazwa}   valChange={valChangeListener} goNext={goNextNew} name="nazwa" placeholder={"Nazwa: "}   />

                                    </div> 


                                     <div className="filter_controll">   
                                            <label>Fakturowanie: </label>                             
                                            <InputCombo items={ [ {v:'_x_', title: '- - -'},  {v:'1', title: 'Wstrzymane'},  {v:'0', title: 'Aktywne'},     ] }   userData={props.userData} value={filterParam.fakturowanie}   valChange={valChangeListener} goNext={goNextNew} name="fakturowanie" placeholder={": "}   />
                                    </div> 


                                    <div className="filter_btn">                       
                                            <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść [esc]</span>
                                    </div> 
                        </div>


                        <div className="table_widget">                             

                              <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                                
                              <InputLegend items={legend}  valChange={valChangeListener} />

                              &nbsp; &nbsp;
                                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title={titleRaport} />   
                                    <Csv tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Xlsx tabRef={tab2Ref}  title={titleRaport} />                  
                                    <Print tabRef={tab2Ref}   title={titleRaport} />

                              <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />  
                        </div>


                        <div className="bg_center">


                                <div ref={tabRef} className="gohide">
                                    <h3>{titleRaport}</h3> 

                                    <table className="table"  ref={tab2Ref}  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                           
                                                <td> </td>                                                                                                                                    
                                                <td>NIP</td>                                                                                                                                    
                                                <td>Nazwa</td>                                                                                                                                    
                                                <td>Umowa</td>                                                                                                                                                                                                                                                                    
                                                <td>Miesiąc -3</td>                                                                                                                                                                                                                       
                                                <td>Miesiąc -2</td>                                                                                                                                                                                                                       
                                                <td>Miesiąc -1</td>                                                                                                                                                                                                                       
                                                <td className="td_right">Miesiąc akt.</td>                                                                                                                                                                                                                                                                                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>

                                           
                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            if(  row.fakturowanie != undefined  && row.fakturowanie.aktualnie_wstrzymano_fakturowanie == '1' )
                                                            {
                                                                rowStyle += " color_show4 " ;
                                                            }

                                                            if(row.do_sprawdzenia == '1')
                                                            {
                                                                    rowStyle += " color_deleted2 " ; 
                                                            }
                                                           
                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>

                                                                <td className="gocenter">
                                                                     {
                                                                        row.fakturowanie != undefined  && row.fakturowanie.aktualnie_wstrzymano_fakturowanie == '1' &&
                                                                        <Fragment>
                                                                            wstrzymane od: {row.fakturowanie.wstrzymane_od }
                                                                            <img  className="tab_ico" src={exmark} title={"Fakturowanie wstrzymane od " +row.fakturowanie.wstrzymane_od   } />                                                                            
                                                                        </Fragment>
                                                                     }
                                                                </td>

                                                                <td className="gocenter">{row.nip}</td>
                                                                <td >{row.nazwa}   </td>
                                                                <td >{row.numer_umowy}</td>
                                                                <td className="gocenter">
                                                                        {
                                                                            row.ostatnie.length > 2 &&
                                                                            <span>{row.ostatnie[2].numer_dokumentu}</span>
                                                                        }
                                                                </td>
                                                                <td>
                                                                        {
                                                                            row.ostatnie.length > 1 &&
                                                                            <span>{row.ostatnie[1].numer_dokumentu}</span>
                                                                        }
                                                                </td>
                                                                <td>
                                                                        {
                                                                            row.ostatnie.length > 0 &&
                                                                            <span>{row.ostatnie[0].numer_dokumentu}</span>
                                                                        }
                                                                </td>

                                                                 <td>
                                                                        {
                                                                            row.aktualne.length > 0 &&
                                                                            <span>{row.aktualne[0].numer_dokumentu}</span>
                                                                        }
                                                                </td>
                                                                                                                   
                                                               
                                                     
                                                            </tr>

                                                    } )
                                                }

                                        </tbody>

                                    </table>
                                </div>

                           

                                <table className="table"  >

                                     <thead>
                                            <tr className="header">                                                                                               
                                                <td className="td_left">LP</td>                                                                                                                                                                           
                                                <td> </td>                                                                                                                                    
                                                <td>NIP</td>                                                                                                                                    
                                                <td>Nazwa</td>                                                                                                                                    
                                                <td>Umowa</td>                                                                                                                                                                                                                                                                    
                                                <td>Miesiąc -3</td>                                                                                                                                                                                                                       
                                                <td>Miesiąc -2</td>                                                                                                                                                                                                                       
                                                <td>Miesiąc -1</td>                                                                                                                                                                                                                       
                                                <td className="td_right">Miesiąc akt.</td>                                                                                                                                                                                                                                                                                                                                                  
                                            </tr>
                                        </thead>

                                        <tbody>

                                           
                                                {
                                                    tab.map( (row, ix) => {

                                                            var rowStyle = " row ";
                                                            if(ix % 2 == 0 )rowStyle = " row2 ";

                                                            if(  row.fakturowanie != undefined  && row.fakturowanie.aktualnie_wstrzymano_fakturowanie == '1' )
                                                            {
                                                                rowStyle += " color_show4 " ;
                                                            }

                                                            if(row.do_sprawdzenia == '1')
                                                            {
                                                                    rowStyle += " color_deleted2 " ; 
                                                            }
                                                           
                                                            return <tr className={rowStyle} key={ix}>
                                                                <td className="gocenter">{ix+1}</td>

                                                                <td className="gocenter">
                                                                     {
                                                                        row.fakturowanie != undefined  && row.fakturowanie.aktualnie_wstrzymano_fakturowanie == '1' &&
                                                                        <Fragment>
                                                                            wstrzymane od: {row.fakturowanie.wstrzymane_od }
                                                                            <img  className="tab_ico" src={exmark} title={"Fakturowanie wstrzymane od " +row.fakturowanie.wstrzymane_od   } />                                                                            
                                                                        </Fragment>
                                                                     }
                                                                </td>

                                                                <td className="gocenter">{row.nip}</td>
                                                                <td >{row.nazwa}   <sup  className="link_normal"  v="client" id={row.fak_kontrahenci_id} onClick={changeView}>idź do klienta</sup>  </td>
                                                                <td >{row.numer_umowy}</td>
                                                                <td className="gocenter">
                                                                        {
                                                                            row.ostatnie.length > 2 &&
                                                                            <span>{row.ostatnie[2].numer_dokumentu}</span>
                                                                        }
                                                                </td>
                                                                <td>
                                                                        {
                                                                            row.ostatnie.length > 1 &&
                                                                            <span>{row.ostatnie[1].numer_dokumentu}</span>
                                                                        }
                                                                </td>
                                                                <td>
                                                                        {
                                                                            row.ostatnie.length > 0 &&
                                                                            <span>{row.ostatnie[0].numer_dokumentu}</span>
                                                                        }
                                                                </td>

                                                                 <td>
                                                                        {
                                                                            row.aktualne.length > 0 &&
                                                                            <span>{row.aktualne[0].numer_dokumentu}</span>
                                                                        }
                                                                </td>
                                                                                                                   
                                                               
                                                     
                                                            </tr>

                                                    } )
                                                }

                                        </tbody>

                                </table>


                        </div>
           
        </div>


}


export default Stoped;